var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sm-select-plan"},[_c('plan-select',{attrs:{"showHidden":false},on:{"submit":_vm.onPlanSubmit}},[_c('template',{slot:"header"},[_c('h2',{staticClass:"sm-txt-center"},[_vm._v("Select a plan")])])],2),_c('company-info'),_c('sm-spinner',{attrs:{"show":_vm.showSpinner}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }